var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0c3.31 0 6 2.66 6 5.95C14 10.41 8 17 8 17S2 10.41 2 5.95C2 2.66 4.69 0 8 0zm0 4a2 2 0 100 4 2 2 0 000-4zm8 13c0 2.21-3.58 4-8 4s-8-1.79-8-4c0-1.29 1.22-2.44 3.11-3.17l.64.91C2.67 15.19 2 15.81 2 16.5 2 17.88 4.69 19 8 19s6-1.12 6-2.5c0-.69-.67-1.31-1.75-1.76l.64-.91C14.78 14.56 16 15.71 16 17z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.62e3002e1f2227275789031f259170b5.svg";
export { ForwardRef as ReactComponent };